import { BCMSCurrency, BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import { CardOnFileMerchant, Transaction, TransactionDispute } from "model";
import TransactionDetailsPage, { getDefaultData } from "components/pages/TransactionDetailsPage";

export default function CaptureTransactionDetails(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor([ Transaction ], controller);
    const { branding } = useModel();
    const options = branding.options ?? {};
    
    let transactionID = "98"; // A credit card transaction id.
    if(options.include_credit_chw23 === "false") {
        transactionID = "5"; // A debit card transaction id.
    }
    const data = BCMSStateManagerCRUD.init(getDefaultData(transactionID))
    .submit();

    return (
        <TransactionDetailsPage data={ data }/>
    );
}